import BeneficiaryAvatar from '../../../../components/BeneficiaryAvatar'
import { Grid, Stack, Typography } from '@mui/material'
import FormatUtils from '../../../../utils/FormatUtils'
import React from 'react'
import { useBreakpoints } from '../../../../components/breakpoints/BreakpointsProvider'

const BeneficiaireContrat = (
	{
		// @ts-ignore
		beneficiaire
	}
) => {

	const { isMobile } = useBreakpoints()

	return (
		<Grid item xs={isMobile ? 12 : 6}>
			<Stack direction="column" alignItems="flex-start" spacing={1} pb="24px">
				<Stack direction="row" spacing={1}>
					<BeneficiaryAvatar size="small" firstname={beneficiaire.prenom} lastname={beneficiaire.nom} type={beneficiaire.typAdr} />
					<Stack direction="column">
						<Typography variant="h4">
							{`${beneficiaire.prenom} ${beneficiaire.nom}`}
						</Typography>
						<Typography variant="subtitle1">
							{`${beneficiaire.libTypAdr} `}
						</Typography>
					</Stack>
				</Stack>
			</Stack>
		</Grid>
	)
}

export default BeneficiaireContrat
